module.exports = "<footer class=\"pb-0\">\r\n    <app-need-help></app-need-help>\r\n    <app-support></app-support>\r\n</footer>"